/**
 * OMEGA admin gate — UX-only visibility control for the `/omega`
 * route and its nav entry.
 *
 * The route is hidden for every viewer except:
 *
 *   - Anyone running a Vite DEV build (`import.meta.env.DEV`). Local
 *     development always has the route.
 *   - Any browser that has `gi-engine.omega-admin = "true"` in
 *     localStorage. The founder unlocks this in production by
 *     visiting `/omega?key=founder` exactly once — see
 *     `pages/OmegaPage.tsx`. Tests set the same flag via the
 *     `seedOmegaAdmin` Playwright fixture.
 *
 * The gate is UX-only — production must still enforce founder
 * identity at the server's `POST /omega/genesis` route via signed
 * founder-key challenge. This file is the client surface, not a
 * security boundary.
 */

const STORAGE_KEY = 'gi-engine.omega-admin';

export function isOmegaAdmin(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export const OMEGA_ADMIN_STORAGE_KEY = STORAGE_KEY;
